window.addEventListener("cart_changed", () => {
  setTimeout(() => {
    const listRows= document.querySelectorAll('.cart__row[data-cart-item-key]')
    if(listRows.length){
      listRows.forEach((row) => {
        const attrKey = row.getAttribute('data-cart-item-key')
        const priceEles = row.querySelectorAll('span[bss-b2b-cart-item-key], dd[bss-b2b-cart-item-key]')
        if(priceEles.length) {
          priceEles.forEach((ele) => {
            ele.setAttribute('bss-b2b-cart-item-key', attrKey)
            BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false)
            console.log('change')
          })
        }
      })
    }
    
  }, 100)
});
setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $('.cart__submit.btn').addClass('bss_checkout')
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'input[name="checkout"]', handleButtonClick);
  }, 500)